import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Card } from '@shopify/polaris';

import { clearSessionToken } from '../../warehouse/utils/session';
import { useSessionProfile, roleLabels } from '../../warehouse/utils/permissions';
import { useDocumentTitle } from '../../warehouse/utils/a11y';

const EMPLOYEE_LOGIN_KEY = 'employeeLogin';

const WarehouseProfile = () => {
  useDocumentTitle('Profile');
  const navigate = useNavigate();
  const [employeeLogin, setEmployeeLogin] = useState('');
  const { loaded, profile } = useSessionProfile();

  useEffect(() => {
    try {
      const login = localStorage.getItem(EMPLOYEE_LOGIN_KEY);
      if (login) {
        setEmployeeLogin(login);
      }
    } catch (error) {
      console.error('Error loading employee login:', error);
    }
  }, []);

  const handleLogout = async () => {
    try {
      await clearSessionToken();
      localStorage.removeItem(EMPLOYEE_LOGIN_KEY);
      navigate('/warehouse/app/login', { replace: true });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const location = profile?.location;
  const locationText = !loaded
    ? 'Loading...'
    : location?.label || (location?.id != null ? `Location ${location.id}` : 'Unknown');
  const roles = roleLabels(profile?.permissions);
  const roleText = !loaded
    ? 'Loading...'
    : roles.length > 0
      ? roles.join(', ')
      : 'No roles assigned';

  return (
    <div className="warehouse-screen">
      <div className="warehouse-header">
        <h2>Profile</h2>
        <div className="warehouse-header-subtitle">User information</div>
      </div>

      <div className="warehouse-list">
        <Card>
          <span className="warehouse-info-label">Employee Login</span>
          <p>{employeeLogin || 'Not logged in'}</p>
        </Card>
        <Card>
          <span className="warehouse-info-label">Location</span>
          <p>{locationText}</p>
        </Card>
        <Card>
          <span className="warehouse-info-label">Role</span>
          <p>{roleText}</p>
        </Card>
        <Button variant="primary" tone="critical" onClick={handleLogout}>Log Out</Button>
      </div>
    </div>
  );
};

export default WarehouseProfile;
